import { MATERIAL_SUMMARY_TO_DATE_ELEMENT_ID } from '../constants/material-summary.constants';
import { localCalendarDateOnlyToday } from './local-calendar-date-only-today.util';

/**
 * Per-render defaults for Material Summary date inputs (e.g. "to" defaults to today for range mode).
 */
export function getMaterialSummaryDateFieldRendererDefaults(): Readonly<Record<string, string>> {
    return {
        [MATERIAL_SUMMARY_TO_DATE_ELEMENT_ID]: localCalendarDateOnlyToday(),
    };
}
